import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {


  onlineStatus: boolean = navigator.onLine;

  @HostListener('window:offline', ['$event'])
  onOffline(event: Event) {
    this.onlineStatus = false;
    console.log('Sin conexión a Internet');
  }

  @HostListener('window:online', ['$event'])
  onOnline(event: Event) {
    this.onlineStatus = true;
    console.log('Conexión a Internet restaurada');
  }

  constructor(private router: Router,private permissionsService : NgxPermissionsService 
    ) { }


  ngOnInit() {
      let rol:string [];
      rol=[];
      rol.push(localStorage.getItem('rol'));
    this.permissionsService.loadPermissions(rol);
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
